function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "a",
  d: "M0 .08h124.966v66.471H0z"
}), React.createElement("path", {
  id: "c",
  d: "M.129.016h124.966v66.471H.13z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#FFF",
  d: "M2.186 61.57l13.477 5.795 1.797 10.377 119.495 1.642-1.797-60.536-11.68-9.883-4.492-6.289H2.186"
}), React.createElement("g", {
  transform: "translate(.062 .77)"
}, React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#a"
})), React.createElement("path", {
  fill: "#0096D6",
  stroke: "#FFF",
  d: "M9.077 66.551h-.436C3.877 66.551 0 62.675 0 57.911V.08h116.325c4.765 0 8.641 3.876 8.641 8.64v.617h-3.988v-.617a4.659 4.659 0 0 0-4.653-4.653H3.988V57.91a4.659 4.659 0 0 0 4.653 4.653h.436v3.988z",
  mask: "url(#b)"
})), React.createElement("g", {
  transform: "translate(13.193 14.178)"
}, React.createElement("mask", {
  id: "d",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#c"
})), React.createElement("path", {
  fill: "#0096D6",
  stroke: "#FFF",
  d: "M4.117 4.004v53.842a4.659 4.659 0 0 0 4.653 4.653h112.337V8.657a4.659 4.659 0 0 0-4.653-4.653H4.117zm120.978 62.483H8.77C4.006 66.487.13 62.61.13 57.846V.016h116.325c4.765 0 8.641 3.876 8.641 8.64v57.831z",
  mask: "url(#d)"
})), React.createElement("path", {
  fill: "#0096D6",
  stroke: "#FFF",
  d: "M57.252 24.857H23.936V70.07h33.142c-6.46-5.375-10.575-13.474-10.575-22.535 0-9.142 4.188-17.305 10.75-22.678m-9.005 3.988a33.172 33.172 0 0 0-5.733 18.69 33.2 33.2 0 0 0 5.64 18.546h-20.23V28.845h20.323M127.674 24.857H94.358c6.561 5.373 10.75 13.536 10.75 22.678 0 9.061-4.115 17.16-10.575 22.535h33.141V24.857zm-3.988 3.988V66.08h-20.23a33.2 33.2 0 0 0 5.64-18.546c0-6.763-2.028-13.24-5.734-18.69h20.324z"
}), React.createElement("path", {
  fill: "#0096D6",
  d: "M81.62 54.427c0-.744-.079-1.362-.233-1.858a2.903 2.903 0 0 0-.77-1.253c-.357-.341-.816-.643-1.375-.906-.56-.262-1.26-.534-2.098-.812l-.718 9.796c2.01-.061 3.377-.534 4.104-1.417.727-.881 1.09-2.065 1.09-3.55zM70.477 40.173c0 1.362.333 2.36.997 2.994.666.636 1.772 1.2 3.32 1.695l.72-9.239c-1.898.093-3.211.527-3.941 1.3-.731.774-1.096 1.857-1.096 3.25zm2.889 22.982c-2.077-.155-3.705-.402-4.883-.743-1.178-.34-1.767-.882-1.767-1.625v-2.09c.802.093 1.829.218 3.08.372 1.251.155 2.523.248 3.82.278l.859-10.4a29.24 29.24 0 0 1-3.345-1.299c-.991-.464-1.836-1.021-2.532-1.672a6.77 6.77 0 0 1-1.627-2.344c-.387-.913-.58-2.02-.58-3.32 0-2.785.8-4.858 2.398-6.221 1.6-1.362 3.952-2.074 7.058-2.136l.295-4.364h1.81c.65 0 .943.31.882.929l-.267 3.435c4.015.28 6.024 1.053 6.024 2.321v1.904a59.652 59.652 0 0 0-2.97-.325 109.89 109.89 0 0 0-3.34-.232l-.728 9.935c1.297.403 2.446.82 3.45 1.254 1.004.434 1.86.968 2.571 1.602.71.634 1.25 1.423 1.622 2.368.37.944.555 2.128.555 3.551 0 1.61-.224 2.972-.673 4.086-.45 1.114-1.085 2.02-1.906 2.716-.82.696-1.827 1.2-3.02 1.508-1.192.31-2.532.48-4.02.512l-.362 4.643h-1.81c-.651 0-.946-.31-.882-.93l.288-3.713z"
}));

var SvgCashIcon = function SvgCashIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 141,
    height: 82,
    viewBox: "0 0 141 82",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCashIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cash-icon.1c642e9e.svg";
export { ForwardRef as ReactComponent };